import {Component, Input, OnInit} from '@angular/core';
import {ProductService} from '@services/product.service';
import {Startup} from '@services/model/startup';
import {LinkType} from '@services/resource/link-type';
import {productCategories, ProductGroup} from '@app/product-group-select/product-group-select.component';
import Required from '@util/decorators/required';
import {UUID} from '@util/types';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {Produktblatt} from '@services/model/produktblatt';
import {Product} from '@services/model/product';
import {UserType} from '@services/resource/user-type';
import {VoilaUserService} from '@services/voila-user.service';
import {ProductStateTranslate} from '@util/pipes/product-state-translate';
import {Application} from '@services/model/application';
import {IImage} from '@services/resource/iimage';
import {CollapsibleComponent} from '@widgets/collapsible/collapsible.component';
import {CommonModule} from '@angular/common';
import {MarkantElementsModule} from '@markant/elements-angular';
import {MediaListPublishedComponent} from '@app/media-list-published/media-list-published.component';
import {UvpPipe} from '@util/pipes/UvpPipe';
import {LinkHttpPipe} from '@util/pipes/http-link-pipe';
import {MomentPipe} from '@util/pipes/moment-pipe';

@Component({
  selector: 'app-product-view',
  templateUrl: './product-view.component.html',
  styleUrls: ['./product-view.component.scss'],
  standalone: true,
  imports: [CommonModule, CollapsibleComponent, MarkantElementsModule, MediaListPublishedComponent, UvpPipe, LinkHttpPipe, MomentPipe],
})
export class ProductViewComponent implements OnInit {
  @Required @Input() productId: UUID;

  LinkType = LinkType;
  Startup = Startup;
  userType = UserType;

  public produktblatt$: Observable<Produktblatt>;
  public images$: Observable<IImage[]>;
  public images: string[];
  public mainImage$: Observable<IImage | undefined>;
  public applications$: Observable<string[]>;

  constructor(
    readonly userService: VoilaUserService,
    private readonly productService: ProductService,
    private readonly productStatePipe: ProductStateTranslate,
  ) {}

  ngOnInit(): void {
    this.produktblatt$ = this.productService.getProduktblatt(this.productId);
    this.images$ = this.produktblatt$.pipe(map((p) => p.product.productImages.map((i) => ({url: i.uri}) as IImage)));
    this.mainImage$ = this.produktblatt$.pipe(
      map((p) => {
        return p.product.productImages && p.product.productImages.length > 0 ? ({url: p.product.productImages[0].uri} as IImage) : undefined;
      }),
    );
    this.applications$ = this.produktblatt$.pipe(
      map((p) => p.applications.sort((app1, app2) => app1.cycle.pitchDate.diff(app2.cycle.pitchDate)).map((app) => this.buildApplicationOutput(app))),
    );
  }

  private buildApplicationOutput(app: Application): string {
    const pitchDate = app.cycle.pitchDate.locale('de').format('MMM YYYY');
    const applicationState = this.productStatePipe.transform(app.productStatus);
    return this.isMa() ? `${pitchDate} (${applicationState})` : `${pitchDate}`;
  }

  productGroupViewValue(value: string): string {
    const productGroup = productCategories
      .map((pc) => pc.productGroups.find((a: ProductGroup) => a.value === value))
      .filter((a) => a)
      .pop();
    return productGroup ? productGroup.viewValue : '';
  }

  getContactName(startup: Startup): string {
    let contactName = startup.contact.firstName + ' ' + startup.contact.lastName;
    if (this.isMa()) {
      contactName += ' (' + startup.createdByMnet + ')';
    }
    return contactName;
  }

  isMa(): boolean {
    const user = this.userService.currentUser();
    return user && user.userType === UserType.MA;
  }

  shortenName(name: string) {
    if (name.length > 32) {
      return name.substring(0, 30) + '... .pdf';
    }
    return name;
  }
}
